import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSpeechBubbleEmpty20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconSpeechBubbleEmpty20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.45 14v3.012l3.423-2.691.408-.321H16.5a1 1 0 0 0 1-1V5.5a1 1 0 0 0-1-1h-13a1 1 0 0 0-1 1V13a1 1 0 0 0 1 1zm4.35 1.5h5.7A2.5 2.5 0 0 0 19 13V5.5A2.5 2.5 0 0 0 16.5 3h-13A2.5 2.5 0 0 0 1 5.5V13a2.5 2.5 0 0 0 2.5 2.5h1.45v2.541a1 1 0 0 0 1.618.787z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSpeechBubbleEmpty20);
